import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import tags from './tags'
import auth from './auth'
import opportunities from './opportunities'
import opportunity from './opportunity'
import markets from './markets'
import useCases from './useCases'
import organization from './organization'
import verticals from './verticals'
import vip from './vip'

const rootReducer = combineReducers({
  tags,
  auth,
  opportunities,
  opportunity,
  markets,
  routing,
  useCases,
  organization,
  verticals,
  form,
  vip
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js